<div class="main-content">
  <div class="container-fluid">
    <!--<div style="float: right; margin-right: 20px" class="row">
         <button (click)="openNuevoCompany()" mat-raised-button class="btn btn-success">
                <span class="btn-label">
                  <i class="material-icons">note_add</i>
                </span>
                 New Company
              </button>
      </div>-->
    <div class="clearfix"></div>
    <div>
      <div class="col-md-12">
        <div class="card">
          <!--                   <div class="card-header card/-header-primary card-header-icon">
                    <div class="card-icon">
                      <i class="material-icons">assignment</i>
                    </div>
                    <h4 class="card-title">Company's List</h4>
                  </div> -->
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center">
              <app-button-select
                [options]="optionsButtonSelect"
                [(selected)]="optionSelectMenuTrigger"
                (selectedChange)="menuTriggerToShow($event)"
                [label]="'Status'"
                [widthPx]="138"
                [specialWidth]="272"
              >
              </app-button-select>

              <button
                class="gts-btn-primary btnWidth"
                matRipple
                (click)="openNuevoCompany()"
              >
                <span class="gts-btn-icon-left">add</span>
                <span class="gts-btn-text">Company</span>
              </button>
            </div>
            <hr />
            <!--  <div class="toolbar"> -->
            <!--        Here you can write extra buttons/actions for the toolbar              -->
            <!--   </div> -->

            <!--                         <div class="row">
                          <div class="col-md-12" style="text-align: right;">
                            <div style="float: right; margin-right: 20px" class="row">
                      
                              <button (click)="openNuevoCompany()" mat-raised-button class="btn btn-success">
                                <span class="btn-label">
                                  <i class="material-icons">note_add</i>
                                </span>
                                 New Company
                              </button>

                              &nbsp;&nbsp;

                              <button type="button" class="btn btn-outline-{{activos === 1 ? 'info' : 'danger'}}" (click)="cambiarActivos()">
                                <i class="fa fa-eye" aria-hidden="true"></i> Show {{activos === 1 ? 'Inactive' : 'Active'}} Companies
                              </button>
                            </div>
                          </div>
                        </div> -->
            <div *ngIf="cargando" style="text-align: center">
              <h2>
                <b
                  ><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                  Loading...</b
                >
              </h2>
            </div>
            <!-- <app-companies-table *ngIf="!cargando" [elements]="companiess" (out)="boton($event)"></app-companies-table>-->

            <div style="position: relative">
              <section [ngClass]="getClass()" *ngIf="bulk.length > 0">
                <div style="display: flex">
                  <div class="title-actions">
                    <b class="gts-btn-text">{{ bulk.length }} Selected: </b>
                  </div>

                  <button
                    class="gts-btn-primary-outline-actions-end"
                    matRipple
                    [matTooltip]="activos === 1 ? 'Inactive' : 'Active'"
                    (click)="DeleteMultiple()"
                    [disabled]="bulk.length === 0"
                  >
                    <span class="gts-btn-icon">
                      {{ activos === 1 ? "close" : "check" }}
                    </span>
                  </button>
                </div>
              </section>
              <div [ngClass]="getClassConta()">
                <dinamic-table
                  *ngIf="!cargando"
                  [id]="'companiescomponentTable'"
                  [dbname]="'companiescomponentTable'"
                  [frontpaginate]="false"
                  [data]="staffData"
                  [config]="config"
                  (action_button)="actions($event)"
                  (newConfig)="updateConfig($event)"
                  [columnfilters]="filtros"
                  (buscar)="getData($event)"
                  [perPage]="pageLimit"
                  [page]="page"
                  [bulk]="bulk"
                  [total_items_count]="totalItems"
                  [total_pages]="totalPaginas"
                  (rightClickAction)="handleRightClick($event)"
                  (toggleButtons)="onToggleButtons($event)"
                ></dinamic-table>
              </div>
            </div>
          </div>
          <!-- end content-->
        </div>
        <!--  end card  -->
      </div>
      <!-- end col-md-12 -->
    </div>
    <!-- end row -->
  </div>
</div>
<div
  class="modal fade"
  id="myModalTax"
  tabindex="-1"
  role="dialog"
  data-backdrop="static"
  aria-labelledby="exampleModalScrollableTitle"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h3
          style="font-size: 18px"
          class="modal-title"
          id="exampleModalScrollableTitle"
        >
          <b>Do you want to Create Tax Excemption for {{ newCompanyName }} ?</b>
        </h3>
        <button
          (click)="closeTax()"
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="card-body">
        <mat-stepper [linear]="true">
          <mat-step label="Tax Information">
            <mat-form-field class="mr-3" *ngIf="states.length > 0">
              <mat-label>For Which State?</mat-label>
              <mat-select
                name="state"
                #state="ngModel"
                [(ngModel)]="state_id"
                required
              >
                <mat-option *ngFor="let state of states" [value]="state.id">
                  {{ state.abbr }} - {{ state.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field>
              <mat-label>Tax Exempt Registration Number</mat-label>
              <input
                matInput
                type="text"
                name="taxNumber"
                [(ngModel)]="taxNumber"
                required
              />
            </mat-form-field>
            <button
              class="gts-btn-primary-outline"
              matRipple
              (click)="saveTaxAndNext()"
              [disabled]="!taxNumber || !state_id"
            >
              <span class="gts-btn-icon-left">east</span
              ><span class="gts-btn-text">Next</span>
            </button>
          </mat-step>
          <mat-step label="Resale Tax Certificate">
            <app-multi-files
              *ngIf="showMultiFiles"
              [fileUrl]="fileURL"
              [idfather]="taxId"
              [type]="'ResaleTaxCertificateCompany'"
              (fileUrlChange)="fileURL = $event"
            ></app-multi-files>
            <div class="d-flex justify-content-end">
              <button
                [disabled]="!state_id || !taxNumber || !fileURL"
                type="button"
                class="gts-btn-primary-outline mt-4 mr-2"
                (click)="saveEditTax('add')"
              >
                <span class="gts-btn-icon-left"> add </span>
                <span class="gts-btn-text">
                  Save and add Another Tax Exempt
                </span>
              </button>
              <button
                [disabled]="!state_id || !taxNumber || !fileURL"
                type="button"
                class="gts-btn-primary mt-4"
                (click)="saveEditTax('finish')"
              >
                <span class="gts-btn-icon-left">save</span>
                <span class="gts-btn-text"> Save and Exit </span>
              </button>
            </div>
          </mat-step>
        </mat-stepper>
      </div>
    </div>
  </div>
</div>
